const BaseComponent = require( 'base/base-component' );
const { lunar } = require( 'helper/util' );

class ZcyGXHeaderSearch extends BaseComponent {
  constructor() {
    super( {
      events: {
        'input .mainkeyword': 'showClear',
        'click .icon-Shape': 'clear',
        'keydown .mainkeyword': 'globalSearch',
        'click .Jsearch': 'globalSearch'
      }
    } );
    this.$input = this.$el.find( '.mainkeyword' );
  }

  init() {
    this.initCalendar();
    super.init();
  }

  initCalendar() {
    const date = new Date();
    const _y = date.getFullYear();
    const _m = date.getMonth() + 1;
    const _d = date.getDate();
    const _nl = lunar();
    const _w = [ '日', '一', '二', '三', '四', '五', '六' ];
    const week = new Date().getDay();
    this.$el.find( '.calendar .date' ).text( `${ _y }年${ _m }月${ _d }日` );
    this.$el.find( '.calendar .week' ).text( `星期${ _w[ week ] }` );
    this.$el.find( '.calendar .lunar' ).text( `农历${ _nl }` );
  }

  clear( e ) {
    this.$input.val( '' );
    $( e.target ).hide();
  }

  showClear( e ) {
    const $ele = $( e.target || e.srcElement );
    if ($ele.val().length > 0) {
      this.$el.find( '.icon-Shape' ).show();
    } else {
      this.$el.find( '.icon-Shape' ).hide();
    }
  }

  globalSearch( e ) {
    if (e.type === 'keydown' && e.keyCode !== 13) {
      return;
    }
    const k = this.$el.find( '.mainkeyword' ).val();
    location.href = `/full/search.html?k=${ encodeURIComponent( k ) }`;
  }


}

module.exports = ZcyGXHeaderSearch;
